<template>
    <span class="cart-btn" @click="toggle(false)">
<!--        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path-->
<!--                d="M22.081 23.0003L20.6206 6.73643C20.5808 6.29228 20.2085 5.95207 19.7626 5.95207H16.751V4.59377C16.751 2.06231 14.6916 0.00280762 12.1602 0.00280762C9.629 0.00280762 7.56984 2.06231 7.56984 4.59377V5.95207H4.5561C4.11022 5.95207 3.73797 6.29228 3.69811 6.73643L2.23196 23.0643C2.21037 23.3053 2.291 23.5441 2.45421 23.7226C2.61742 23.901 2.84817 24.0027 3.08994 24.0027H21.2289C21.2296 24.0027 21.2305 24.0027 21.2312 24.0027C21.707 24.0027 22.0926 23.617 22.0926 23.1413C22.0925 23.0934 22.0886 23.0462 22.081 23.0003ZM9.2927 4.59377C9.2927 3.0123 10.5791 1.72567 12.1603 1.72567C13.7417 1.72567 15.0282 3.0123 15.0282 4.59377V5.95207H9.2927V4.59377ZM4.03223 22.2799L5.34367 7.67493H7.56984V9.21539C7.56984 9.69113 7.95541 10.0768 8.43127 10.0768C8.90712 10.0768 9.2927 9.69113 9.2927 9.21539V7.67493H15.0282V9.21539C15.0282 9.69113 15.4138 10.0768 15.8896 10.0768C16.3655 10.0768 16.7511 9.69113 16.7511 9.21539V7.67493H18.9752L20.2866 22.2799H4.03223Z"-->
<!--                fill="white"/>-->
<!--        </svg>-->
      <div id="product-cart-amount-new" class="header-bottom-new-buttons__item circle">
        <span v-if="productsQty > 0">
          <a href="#">{{ productsQty }}</a>
        </span>
        <span v-else>
          <a href="#">0</a>
        </span>
      </div>
        <img class="header-bottom-new-buttons__item" src="/client/img/base/basket.png"/>

<!--        <div id="product-cart-amount"><span v-if="productsQty > 0">{{ productsQty }}</span></div>-->

      <div class="success-card-info">
          <div class="info-cart-logo">
            <svg width="40" height="22" viewBox="0 0 40 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M32.5817 20.57C32.509 20.6864 32.4362 20.8318 32.378 20.9482C32.378 20.8318 32.378 20.7009 32.349 20.57L32.2762 20.1482H31.9562L31.6362 21.21H31.8544L31.9708 20.7882L32.0871 20.3373C32.1017 20.4682 32.1162 20.5991 32.1308 20.73L32.2035 21.1809H32.378L32.669 20.73C32.7562 20.5991 32.8435 20.4537 32.9162 20.3228C32.9162 20.4682 32.858 20.6282 32.8435 20.7591L32.7708 21.1955H33.0035L33.1635 20.1337H32.858L32.5817 20.57Z" fill="white"/>
              <path d="M31.738 20.1482H30.7635L30.7344 20.3082H31.098L30.8944 21.21H31.1416L31.3307 20.3082H31.6944L31.738 20.1482Z" fill="white"/>
              <path d="M26.153 0.00273307C23.8258 -0.0554487 21.5712 0.817278 19.8985 2.43182C17.7603 4.46819 15.3312 6.78091 14.4585 7.61001H36.1894L40.0003 0.00273307H26.153Z" fill="white"/>
              <path d="M10.7782 11.13L0 21.37H25.1927C25.4255 21.37 29.2945 21.5155 30.6764 18.7228L34.4436 11.1155H10.7782V11.13Z" fill="white"/>
            </svg>
          </div>
          <span>
המוצר נוסף לעגלה בהצלחה
          </span>
        </div>
    </span>
  <teleport to="body">
    <transition name="fade">
      <div v-if="isOpen" class="cart-modal__wrapper scroller">
        <div class="cart-modal">
          <div class="cart-modal__header">
            <div class="headline-sm">סל הקניות שלך</div>
            <div class="cart-modal__close close--icon" @click="toggle(true)">
              <svg width="21" height="20" viewBox="0 0 21 20" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9375 9.99995L19.7943 2.21211C20.3056 1.70554 20.3056 0.886492 19.7943 0.379925C19.2833 -0.126642 18.4569 -0.126642 17.9459 0.379925L10.0888 8.16777L2.23195 0.379925C1.72064 -0.126642 0.894552 -0.126642 0.383482 0.379925C-0.127827 0.886492 -0.127827 1.70554 0.383482 2.21211L8.24031 9.99995L0.383482 17.7878C-0.127827 18.2944 -0.127827 19.1134 0.383482 19.62C0.638179 19.8727 0.973067 19.9996 1.30772 19.9996C1.64237 19.9996 1.97701 19.8727 2.23195 19.62L10.0888 11.8321L17.9459 19.62C18.2008 19.8727 18.5354 19.9996 18.8701 19.9996C19.2047 19.9996 19.5394 19.8727 19.7943 19.62C20.3056 19.1134 20.3056 18.2944 19.7943 17.7878L11.9375 9.99995Z"
                    fill="#00000F"/>
              </svg>
            </div>
          </div>
          <div class="cart-modal__purchases">
            <div class="cart-items">
              <cart-item
                v-for="(cartItem, pIdx) in cartData.products"
                :key="cartItem.id"
                v-model="cartData.products[pIdx]"
                @update="updateCartQuantity"
                @remove="removeCartItem"
              />
<!--              <cart-item-->
<!--                v-for="(cartItem, pIdx) in processedProducts"-->
<!--                :key="cartItem.id"-->
<!--                v-model="processedProducts[pIdx]"-->
<!--                @update="updateCartQuantity"-->
<!--                @remove="removeCartItem"-->
<!--              />-->
            </div>
            <div class="cart-modal__purchases-clear text" @click="onClear">
              הסר הכל
            </div>
            <div class="cart-modal__purchases-coupon">
              <input type="text" placeholder="הזן קוד קופון" v-model="coupon" :class="couponSuccess ? 'input-success' : ''">
              <div v-if="couponSuccess" class="add-coupon success">הפעל</div>
              <div v-else class="add-coupon" @click="onCouponAdd">הפעל</div>
            </div>
            <div v-if="couponError" class="coupon-error">הקופון שהזנת אינו תקין. נסה שנית.</div>
            <div style="display: none;" class="cart-modal__purchases-gift">
              <input type="text" placeholder="הזן Card Gift">
            </div>
          </div>
          <div :class="MobileOperatingSystem === 'iOS' ? 'cart-modal__footer footer-ios' : 'cart-modal__footer'">
            <div v-if="saleSum" class="current-sum-discount">
              <div class="cart-modal__footer-total">
                <span>הנחה:</span>
                <span>{{ saleSum }}</span>
              </div>
            </div>
            <div class="cart-modal__footer-total">
              <div class="discount">
                <span v-if="couponSuccess" class="discount-text">הנחת קופון</span>
                <span>{{ cartTotal.title }}</span>
              </div>
              <div class="discount">
                <span v-if="couponSuccess" class="discount-value" dir="ltr">- {{discount}}</span>
                <div v-if="discountSale > 0">
                  <div class="ne-headline-sm">
                    ₪{{ totalSum }}
                  </div>
                </div>
                <span>{{ cartTotal.value_text }}</span>
              </div>
            </div>
            <button class="btn-black" onclick="window.location = route('client.checkout.index')" aria-label="לקופה">לקופה</button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>
<style lang="scss" scoped>
  .current-sum-discount {
    div {
      color: #00B6EB;
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 0;
    }
  }
</style>
<script>
import CartItem from './cart-item'

export default {
  name: 'Cart',
  components: {CartItem},
  props: {},
  data() {
    return {
      accountUrl: route('client.about'),
      isLogged: window.isLogged,
      isOpen: false,
      component: "Login",
      cartData: {
        products: [],
      },
      saleSum: null,
      coupon: null,
      couponError: false,
      couponSuccess: false,
      discount: null,
      // processedProducts: [], // Локальная копия обработанных продуктов,
      totalSum: null,
      discountSale: null
    }
  },
  computed: {
    productsQty() {
         return this.cartData.products.reduce((a, i) => a + i.quantity, 0)
    },
    cartTotal() {
      let totalSale = 0;
      if(this.cartData.sale) {
        let ranges = JSON.parse(this.cartData.sale.ranges);
        let totalCard = this.cartData.products.reduce((a, i) => a + i.line_price * i.quantity - totalSale, 0)
        let currentSaleSum = 0;
        ranges.forEach(function (saleItem) {
          if(totalCard >= saleItem.from && totalCard <= saleItem.to) {
            totalSale = saleItem.sale
            currentSaleSum = '₪' + totalSale
          }
        });
        this.saleSum = currentSaleSum
      }

      // this.discountSale = 0;
      // if (this.processedProducts.length > 0) {
      //   for (let i = 0; i < this.processedProducts.length; i++) {
      //     this.discountSale += this.processedProducts[i].discount;
      //   }
      // }
      //
      // // console.log('this.cartData.products.countCart')
      //
      // let value_text = '₪' + this.cartData.products.reduce((a, i) => a + i.line_price * i.quantity - totalSale, 0);
      // this.totalSum = Number(value_text.replace('₪', ''));
      // value_text = '₪' + (this.totalSum - this.discountSale);

      this.discountSale = 0;
      if (this.cartData.products.length > 0) {
          for (let i = 0; i < this.cartData.products.length; i++) {
            this.discountSale += this.cartData.products[i].productDiscount;
          }
        }

      let value_text = '₪' + this.cartData.products.reduce((a, i) => a + i.line_price * i.quantity - totalSale, 0);
      this.totalSum = Number(value_text.replace('₪', ''));
      value_text = '₪' + (this.totalSum - this.discountSale);

      return {
        title: 'סה”כ:',
        // value_text: '₪' + this.cartData.products.reduce((a, i) => a + i.line_price * i.quantity - totalSale - i.discount, 0),
        value_text: value_text,
      }
    },
    MobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
       // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }
      if (/android/i.test(userAgent)) {
        return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }
      return "unknown";
    }
  },
  mounted() {
    // onClose(this.$options.name, () => { this.isOpen = false});
    window.addEventListener('cartUpdated', this.loadCartData)
    this.loadCartData();
    window.addEventListener('keyup', ev => {
      if (ev.keyCode === 27) {
        this.closeModal()
      }
    });
    // const localProducts = this.cartData.products;
    // const sale = this.processCartData(localProducts);
    // const updatedProducts = this.updateProductsBasedOnSale(localProducts, sale);
    // this.processedProducts = updatedProducts;
    // this.cartData.products = updatedProducts;
    // const sale = this.processCartData(this.cartData.products);
    // this.cartData.products = this.updateProductsBasedOnSale(this.cartData.products, sale);
  },
  beforeUnmount() {
    window.removeEventListener('cartUpdated', this.loadCartData)
  },
  methods: {
    // processCartData(products) {
    //   console.log("prod",products)
    //   const sale = [];
    //   const categoryMap = new Map();
    //
    //   products.forEach(item => {
    //     item.discount = 0;
    //     if (item.is_sale) {
    //       const category = item.category_sale;
    //       if (!categoryMap.has(category)) {
    //         categoryMap.set(category,[]);
    //       }
    //       // variant 1 - one product in the category
    //       // categoryMap.get(category).push({
    //       //   product_id: item.product_id,
    //       //   price: item.price,
    //       //   sum_sale: item.sum_sale
    //       // });
    //
    //       // variant 2 - every second product in the category
    //       for (let i = 0; i < item.quantity; i++) {
    //         categoryMap.get(category).push({
    //           product_id: item.product_id,
    //           price: item.price,
    //           sum_sale: item.sum_sale
    //         });
    //       }
    //     }
    //   });
    //
    //   categoryMap.forEach((productsInCategory, category) => {
    //     if (productsInCategory.length >= 2) {
    //       // variant 1 - one product in the category
    //       // const minPriceProduct = productsInCategory.reduce((min, current) => {
    //       //   return current.price < min.price ? current : min;
    //       // }, productsInCategory[0]);
    //       // sale.push(minPriceProduct);
    //
    //       // variant 2 - every second product in the category
    //       productsInCategory.sort((a, b) => a.price - b.price);
    //       // productsInCategory.reduce((min, current) => {
    //       //   return current.price < min.price ? current : min;
    //       // });
    //
    //       let count = productsInCategory.length;
    //       let index = Math.floor(count/2);
    //       for (let i = 0; i < index; i++) {
    //         sale.push(productsInCategory[i]);
    //       }
    //     }
    //   });
    //
    //   return sale;
    // },
    //
    // updateProductsBasedOnSale(localProducts, sale) {
    //   // variant 1 - one product in the category
    //   // const saleIds = sale.map(item => item.product_id);
    //   // //const updatedProductIds = []; // Массив для хранения ID обновленных продуктов
    //   //
    //   // localProducts.forEach(product => {
    //   //   if (saleIds.includes(product.product_id)) { // && !updatedProductIds.includes(product.product_id)) {
    //   //     //console.log(product);
    //   //     //product.line_price -= product.price * (product.sum_sale/100);
    //   //     //updatedProductIds.push(product.product_id); // Добавляем ID продукта в массив обновленных
    //   //   }
    //   //   else {
    //   //     product.is_sale = 0;
    //   //     product.sum_sale = 0;
    //   //   }
    //   // });
    //
    //   // variant 2 - every second product in the category
    //   if (sale.length > 0) {
    //     sale.sort((a, b) => a.product_id - b.product_id);
    //     const sumSale = [];
    //     for (let i = 0; i < sale.length; i++) {
    //       const currentProductId = sale[i].product_id;
    //       const productIndex = localProducts.findIndex(item => item.product_id === currentProductId);
    //       if (productIndex !== -1) {
    //         localProducts[productIndex].discount += (sale[i].price * (sale[i].sum_sale/100));
    //         // this.cartTotal.value_text -= (sale[i].price * (sale[i].sum_sale/100));
    //         // const sum = Number(this.cartTotal.value_text.replace('₪', ''));
    //         // this.cartTotal.value_text = '₪' + (sum - (sale[i].price * (sale[i].sum_sale/100)));
    //       }
    //     }
    //   }
    //
    //   //console.log("localProducts",localProducts);
    //
    //   return localProducts;
    // },

    toggle(isClose) {
      let cart = document.querySelector('#product-cart-amount-new');
      let amountProduct = cart.querySelector('span');
      if(!amountProduct && !isClose) {
        return;
      }
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        document.querySelector('body').classList.add('cart-open')
        //close(this.$options.name);
      } else {
        document.querySelector('body').classList.remove('cart-open')
      }
    },
    closeModal() {
      this.isOpen = false;
      document.querySelector('body').classList.remove('cart-open')
    },
    loadCartData() {
      this.cartData = window.cartData;
      for (let item in this.cartData) {
      }
      if(this.cartData.coupon) {
        this.coupon = this.cartData.coupon.code
        this.couponSuccess = true;
        const sum = Number(this.cartTotal.value_text.replace('₪', ''));
        if(this.cartData.coupon.type === 1) {
          this.discount = '₪' + (Math.round(sum * (this.cartData.coupon.percent) / 100));
        } else {
          this.discount = '₪' + (sum - this.cartData.coupon.amount);
        }
      }
    },
    onClear() {
      let cartItems = [];
      this.cartData.products.forEach((item) => {
        cartItems.push({
          item_name: item.name,
          item_id: item.article,
          price: item.line_price,
          item_brand: "Babolat",
          item_category: item.category,
          quantity: item.quantity
        })
      })
      dataLayer = dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          items: cartItems
        }
      });
      Cart.clear();
    },
    removeCartItem(data) {
      Cart.remove({id: data.item.id})

      dataLayer = dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          items: [{
            item_name: data.item.name,
            item_id: data.item.article,
            price: data.item.line_price,
            item_brand: "Babolat",
            item_category: data.item.category,
            quantity: data.item.quantity
          }]
        }
      });

      // this.processedProducts = [];
      // Cart.remove({ id: data.item.id })
      //   .then(resp => {
      //     if (resp.data.success) {
      //       const products = resp.data.cartData.products;
      //       products.forEach(product => {
      //         this.processedProducts.push(product);
      //       });
      //       this.$nextTick(() => {
      //         const sale = this.processCartData(this.processedProducts);
      //         this.processedProducts = this.updateProductsBasedOnSale(this.processedProducts, sale);
      //       });
      //       this.cartData.products = this.processedProducts
      //     }
      //   })

      // this.processedProducts = [];
      // Cart.remove({ id: data.item.id })
      //   .then(resp => {
      //     if (resp.data.success) {
      //       const products = resp.data.cartData.products;
      //       products.forEach(product => {
      //         this.processedProducts.push(product);
      //       });
      //       this.$nextTick(() => {
      //         const sale = this.processCartData(this.processedProducts);
      //         this.processedProducts = this.updateProductsBasedOnSale(this.processedProducts, sale);
      //       });
      //       this.cartData.products = this.processedProducts
      //     }
      //   })

    },
    updateCartQuantity(data) {
      if (data.item.quantity > 0) {
        if(data.quantity === -1) {
          dataLayer = dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
              items: [{
                item_name: data.item.name,
                item_id: data.item.article,
                price: data.item.line_price,
                item_brand: "Babolat",
                item_category: data.item.category,
                quantity: 1
              }]
            }
          });
        } else {
          dataLayer = dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              items: [{
                item_name: data.item.name,
                item_id: data.item.article,
                price: data.item.line_price,
                item_brand: "Babolat",
                item_category: data.item.category,
                quantity: 1
              }]
            }
          });
        }
        if(data.item.quantity < 99) {
          Cart.update({id: data.item.id, quantity: data.quantity})

          // this.processedProducts.forEach(product => {
          //   if (product.id == data.item.id) {
          //     product.quantity += data.quantity
          //   }
          // });
          // const sale = this.processCartData(this.processedProducts);
          // this.processedProducts = this.updateProductsBasedOnSale(this.processedProducts, sale);
          // this.cartData.products = this.processedProducts
          // // this.cartData.products.forEach(product => {
          // //     if (product.id == data.item.id) {
          // //       product.quantity += data.quantity
          // //     }
          // //   });
          // // // console.log("1",this.cartData.products)
          // // const sale = this.processCartData(this.cartData.products);
          // // this.cartData.products = this.updateProductsBasedOnSale(this.cartData.products, sale);
          // // // console.log("2",this.cartData.products)
        }
      } else if (data.item.quantity === 0 && data.quantity < 0) {
        Cart.getItems()
      } else {
        Cart.add(data.item.variant_id)

      }
    },
    onClickChild(value) {
      this.component = value;
    },
    onCouponAdd() {
      if(this.coupon && this.cartData.products.length) {
        axios.post('/cart/coupon-add', {
          code: this.coupon,
          id: this.cartData.products[0].id,
        }).then((resp) => {
          if(resp.data.success) {
            this.couponError = false;
            this.couponSuccess = true;
            this.discount = resp.data.discount;
            //window.cartData = resp.data.cart;
          } else {
           this.couponError = true;
          }
        }).catch((error) => {
          this.couponError = true;
        })
      }
    }
  }
}
</script>

<style>
#header-cart {
    position: relative;
}
</style>
<style lang="scss" scoped>
    .cart-btn {
      display: flex;
      gap: 6px;
    }

    #product-cart-amount {
        color: #ffffff;
        text-align: center;
        position: absolute;
        bottom: 4px;
        font-size: 10px;
        width: 17px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin-top: 0.5px;
        display: flex;
        justify-content: center;
    }

    @media (max-width: 480px) {
      #product-cart-amount {
        top: 46%;
        left: 45.5%;
      }
    }

    .ne-headline-sm {
      font-size: 18px;
      line-height: 1;
      color: #888888;
      //right: 5%;
      text-decoration: line-through;
      font-weight: 400;
    }
</style>




